/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Addresses from './Addresses/index'
import Heading from './Heading/index'
import NewAddress from './NewAddress/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Address"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Address.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-BkxIm': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-2-BkxIm': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<Addresses
  viewPath={`${viewPath}/Addresses`}
/>
</div>
<NewAddress
  viewPath={`${viewPath}/NewAddress`}
/>
{children}
</React.Fragment>)
}